import styled from 'styled-components';

import type { Props as ButtonProps } from '#src/atoms/buttons/Button/index.tsx';
import { Button } from '#src/atoms/buttons/Button/index.tsx';
import type { IconDefinition } from '#src/atoms/icons/index.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';

export interface Props extends Omit<ButtonProps, 'startIcon'> {
  icon?: IconDefinition;
}

const Root = styled(Button)`
  --size: calc(6 * var(--unit));
  padding: 0;
  display: flex;
  align-items: center;
  /**
  * !important on width/height/border-radius is needed here because Button's
  * .compact/.small/.medium size rules carry equal CSS specificity and are injected first.
  */
  width: var(--size) !important;
  height: var(--size) !important;
  border-radius: var(--size) !important;
  &[aria-disabled='true'] {
    opacity: 0.5;
    pointer-events: none;
  }
  &.compact {
    --size: var(--triple-unit);
  }
  &.small {
    --size: var(--quadruple-unit);
  }
  &.medium {
    --size: calc(5 * var(--unit));
  }
`;
const Label = styled(Horizontal).attrs({ center: true, as: 'span' })`
  && {
    font-size: 16px;
    line-height: 12px;
  }
`;

export const IconButton = (props: Props) => {
  const { children, icon, ref, ...rest } = props;

  return (
    <Root ref={ref} {...rest}>
      <Label>{icon ? <FontAwesomeIcon icon={icon} /> : children}</Label>
    </Root>
  );
};
